<template>
  <v-row>
    <v-col cols="12" md="10" offset-md="1">
      <v-form v-model="mainFormValid" @input="$emit('validate', $event)">
        <ag-number-field
          v-model="internalValue.tokenNumber"
          :label="$t('tokens.demands.fields.tokenNumber')"
          :rules="$options.rules.tokenNumber"
          @input="change"
        />

        <v-textarea
          v-model="internalValue.comment"
          :label="$t('tokens.demands.fields.comment')"
          :rules="$options.rules.comment"
          @input="change"
        />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'

import AgNumberField from 'src/components/common/AgNumberField'

export default {
  name: 'AskTokensForm',
  components: {
    AgNumberField,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tokenNumber: null,
        comment: '',
      }),
    },
  },
  data: () => ({
    internalValue: null,
    mainFormValid: false,
  }),
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.mainFormValid)
    },
  },
  rules: {
    tokenNumber: [
      FormRules.required('error.form.required'),
    ],
    comment: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
